import DOMPurify from 'dompurify';

/** Sanitize HTML before dangerouslySetInnerHTML (DOCX/HTML preview and editor). */
export function sanitizeHtml(html: string): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
